import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './ExcelOrderImport.frontend.types'

@Injectable({ providedIn: 'root' })
export class ExcelOrderImport_RFTESTService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: {  }): Promise<{ output?: string[] }> 
  {
    let url = `${environment.backendUrl}api/ExcelOrderImport/functions/RFTEST`;
    
    const options = {
    }
    
    const body = null;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

